function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "white",
  fillOpacity: 0.25
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.84375 9.26339H7.79018V15.1562H4.84375V9.26339ZM12.2098 7.05357H15.1562V15.1562H12.2098V7.05357ZM8.52679 4.84375H11.4732V15.1562H8.52679V4.84375Z",
  fill: "#EEE"
});
function SvgHourlyStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourlyStat);
export default __webpack_public_path__ + "static/media/hourlyStat.6d5bfbb37a60b68367bd0e8e4aa421c0.svg";
export { ForwardRef as ReactComponent };